import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Drawer from '@mui/material/Drawer';
import Trailers from './Trailers';
import Summary from './Summary';

const initialState = {
  trailers: [],
};

const AddTrailersWizard = ({ onClose, openDrawer }) => {
  const [step, setStep] = useState(1);
  const [trailerState, setTrailerState] = useState(initialState);
  const next = () => setStep(R.inc);
  const prev = () => setStep(R.dec);

  const reset = () => {
    setTrailerState(initialState);
    prev();
  };

  return (
    <Drawer anchor="right" onClose={onClose} open={openDrawer}>
      {step === 1 && (
        <Trailers
          next={next}
          onClose={onClose}
          prev={prev}
          setTrailerState={setTrailerState}
          trailerState={trailerState}
        />
      )}
      {step === 2 && (
        <Summary onClose={onClose} prev={prev} reset={reset} trailerState={trailerState} />
      )}
    </Drawer>
  );
};

AddTrailersWizard.propTypes = {
  onClose: PropTypes.func.isRequired,
  openDrawer: PropTypes.bool,
};
AddTrailersWizard.defaultProps = {
  openDrawer: false,
};

export default AddTrailersWizard;
